<!-- 查询车辆信息接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure.vue"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "carPlateList": [
            {
              "plate": "粤123123",
              "plateColor": 1
            }
          ],
          "startOfBillPayDate":"20230310000000",
          "endOfBillPayDate":"20230420235959",
          "pageNum": 1,
          "pageSize": 10
        },
        responseCode: {
          "data": {
            "currCount": 1,
            "recordList": [
              {
                "billName": "停车费",
                "billCode": "201903251453353",
                "billValue": 10.1,
                "billSuccessDate": "20190325145335"
              }
            ],
            "total": 1
          }, "message": "业务成功", "resultCode": 0, "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台,获取用户账单记录",
          t_url: this.commonUrls.test + "getBillRecord",
          p_url: this.commonUrls.prod + "getBillRecord",
          precondition: "无",
          fitSystem: "VEMS传统停车场，云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              { info1: 'carPlateList', info2: '是', info3: 'JSONArray', info4: '车牌列表(包括车牌号，车牌颜色)' },
              { info1: 'startOfBillPayDate', info2: '是', info3: 'String', info4: '账单支付起始时间，yyyyMMddHHmmss' },
              { info1: 'endOfBillPayDate', info2: '是', info3: 'String', info4: '账单支付结束时间，yyyyMMddHHmmss' },
              {info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始'},
              {info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条'}
            ]
          },{
            titleName: '车牌列表(包括车牌号，车牌颜色)',
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'plate', info2: '是', info3: 'String', info4: '停车流水号' },
              { info1: 'plateColor', info2: '是', info3: 'Integer', info4: '车牌颜色：0其他，1蓝色，2黄色，3白色，4黑色，5绿色（默认为1）' },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              { info1: 'count', info2: '否', info3: 'Integer', info4: '当前取得的记录条数' },
              {info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '用户信息列表'},
            ]
          }, {
            titleName: 'recordList',
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'parkingCode', info2: '是', info3: 'String', info4: '账单流水编号'},
              {info1: 'billCode', info2: '是', info3: 'String', info4: '支付订单号'},
              // {
              //   info1: 'billType',
              //   info2: '是',
              //   info3: 'Integer',
              //   info4: '账单类型：0:停车费，1：充值余额，2：购买月票，3:退款,4:租用车位,5:预约车位,6:余额退款,7:补交停车费,10:扫码支付'
              // },
              {info1: 'billName', info2: '是', info3: 'String', info4: '账单类型名称'},
              {info1: 'shouldBillValue', info2: '是', info3: 'BigDecimal', info4: '应缴费用'},
              {info1: 'billValue', info2: '是', info3: 'BigDecimal', info4: '实付金额'},
              {info1: 'payTime', info2: '是', info3: 'String', info4: '支付时间，格式：yyyyMMddHHmmss'},
              { info1: 'payType', info2: '是', info3: 'int', info4: '支付方式（<url>参考附录:/Api/appendixData</url>）' },
              {info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码'},
              {info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码'},
              {info1: 'couponList', info2: '否', info3: 'JSONArray', info4: '优惠列表'},
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{tableHead: '状态码', tdName: 'info1'}, {tableHead: '说明', tdName: 'info2'}],
            td: [{info1: '000110', info2: '失败',}, {info1: '00110000', info2: '失败',}, {info1: '110000', info2: '失败',}]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getBillRecord.vue